import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Privacy.css';

const CONTACT_EMAIL = 'info@the-patch-guys.com';
const APP_NAME = 'The Patch Guys';
const EMAILJS_SERVICE_ID = 'service_5olnapn';
const EMAILJS_TEMPLATE_ID = 'template_eb3nzxa';

export default function DeleteAccount() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          title: 'Delete My Account',
          name: email,
          email: email,
          message: `Please delete my account and all associated data for the following email address: ${email}`,
        }
      );
      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please email us directly at ' + CONTACT_EMAIL);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="privacy">
      <section className="privacy__hero">
        <div className="container">
          <div className="badge badge-blue" style={{ marginBottom: '20px' }}>Account</div>
          <h1 className="section-title" style={{ color: 'white', marginBottom: '12px' }}>
            Delete Your Account
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '15px' }}>
            We're sorry to see you go. Your data will be permanently deleted within 30 days.
          </p>
        </div>
      </section>

      <section className="section privacy__content">
        <div className="container privacy__body">

          <div className="privacy__intro">
            <p>
              To request deletion of your {APP_NAME} account and all associated data,
              please complete the form below. We will process your request within
              <strong> 30 days</strong> of receiving it.
            </p>
          </div>

          <div className="privacy__section">
            <h2>What gets deleted</h2>
            <p>When you request account deletion, the following data will be permanently removed:</p>
            <ul>
              <li>Your account information (name, email, city, state)</li>
              <li>All child profiles associated with your account</li>
              <li>All scanned team and event patch data</li>
              <li>All game scores and trophy milestones</li>
            </ul>
            <p>
              <strong>Note:</strong> Team and event registrations you submitted will
              not be automatically deleted. To remove a registered team or event,
              please include that request in your message below.
            </p>
          </div>

          <div className="privacy__section">
            <h2>Request account deletion</h2>
            {submitted ? (
              <div style={{
                background: 'rgba(76, 175, 80, 0.08)',
                border: '1px solid rgba(76, 175, 80, 0.3)',
                borderRadius: '12px',
                padding: '24px',
                textAlign: 'center',
              }}>
                <p style={{ fontSize: '18px', fontWeight: '700', marginBottom: '8px', color: '#111827' }}>
                  ✅ Request submitted
                </p>
                <p style={{ color: '#374151' }}>
                  We've received your request and will process it within 30 days.
                  You'll receive a confirmation at <strong>{email}</strong>.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} style={{ maxWidth: '480px' }}>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontWeight: '600',
                    color: '#374151',
                    fontSize: '14px',
                  }}>
                    Email address associated with your account *
                  </label>
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      borderRadius: '10px',
                      border: '1px solid #d1d5db',
                      background: '#f8f9fa',
                      color: '#111827',
                      fontSize: '15px',
                      outline: 'none',
                      boxSizing: 'border-box',
                    }}
                  />
                </div>
                {error && (
                  <p style={{ color: '#dc2626', fontSize: '14px', marginBottom: '12px' }}>
                    {error}
                  </p>
                )}
                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    background: loading ? '#9ca3af' : '#1A6EDB',
                    color: 'white',
                    border: 'none',
                    borderRadius: '10px',
                    padding: '12px 28px',
                    fontSize: '15px',
                    fontWeight: '700',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    width: '100%',
                  }}
                >
                  {loading ? 'Submitting...' : 'Submit Deletion Request'}
                </button>
              </form>
            )}
          </div>

          <div className="privacy__section">
            <h2>Contact us directly</h2>
            <p>
              You can also email us directly at{' '}
              <a href={`mailto:${CONTACT_EMAIL}?subject=Delete My Account`}>
                {CONTACT_EMAIL}
              </a>{' '}
              with the subject line <strong>"Delete My Account"</strong> and include
              the email address associated with your account.
            </p>
            <div className="privacy__contact">
              <p><strong>{APP_NAME}</strong></p>
              <p>Email: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></p>
              <p>Website: <a href="https://the-patch-guys.com" target="_blank" rel="noopener noreferrer">https://the-patch-guys.com</a></p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}